import React, { useEffect, useState } from 'react';
import './data.scss';
import { Outlet, Route, Routes, useLocation, useOutletContext } from 'react-router';
import { Link } from 'react-router-dom';
import sumDataIcon_on from '../../images/sumData_on.png';
import sumDataIcon_off from '../../images/sumData_off.png';
import monitoringIcon_on from '../../images/monitoring_on.png';
import monitoringIcon_off from '../../images/monitoring_off.png';
import axios from 'axios';
import { API_URL } from '../../config/constants';

function Data(props) {
    const { pathname } = useLocation();
    const [sumDsArr, setSumDsArr] = useState([]);
    const [selSumDsId, setSelSumDsId] = useState(-1);
    async function getStructs() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getStructs`);
        const sumDs = response.data.sumDs;
        setSumDsArr([...sumDs]);
        setSelSumDsId(sumDs.length > 0 ? sumDs[0].sumDsId : -1);
    }

    const lastPathName = pathname.split('/')[3];

    const onClickSumDs = (e, id) => {
        e.preventDefault();
        setSelSumDsId(id);
    };

    useEffect(() => {
        getStructs();
    }, [])
    useEffect(() => {
        if (lastPathName === 'sumData' && sumDsArr.length > 0) {
            setSelSumDsId(sumDsArr[0].sumDsId);
        } else if (lastPathName === 'monitoring' && sumDsArr.length > 0) {
            setSelSumDsId(sumDsArr[0].sumDsId);
        }
    }, [lastPathName, sumDsArr]);
    return (
        <div className='dataPage'>
            <div className='dataMenuArea'>
                <ul className='dataMenuUl'>
                    <li className='dataMenuLi'>
                        <Link className={lastPathName === 'sumData' ? 'dataMenuBtn on' : 'dataMenuBtn'} to={'/home/data/sumData'}>
                            <div className='dataMenuIconArea'>

                                <img className='dataMenuIcon' src={lastPathName === 'sumData' ? sumDataIcon_on : sumDataIcon_off} alt={"공정 요약"} />
                            </div>
                            <span>공정 요약</span>
                        </Link>
                        {
                            lastPathName === 'sumData' ?
                                <ul className='subMenuUl'>
                                    {
                                        sumDsArr.map((el, sumDsIdx) => (
                                            <li key={`sumDs_${sumDsIdx}`}>
                                                <button onClick={e => onClickSumDs(e, el.sumDsId)} disabled={selSumDsId === el.sumDsId}>{el.name}</button>
                                            </li>
                                        ))
                                    }
                                </ul>
                                : null
                        }
                    </li>
                    <li className='dataMenuLi'>
                        <Link className={lastPathName === 'monitoring' ? 'dataMenuBtn on' : 'dataMenuBtn'} to={'/home/data/monitoring'}>
                            <div className='dataMenuIconArea'>

                                <img className='dataMenuIcon' src={lastPathName === 'monitoring' ? monitoringIcon_on : monitoringIcon_off} alt={"세부 데이터"} />
                            </div>
                            <span>세부 데이터</span>
                        </Link>
                        {
                            lastPathName === 'monitoring' ?
                                <ul className='subMenuUl'>
                                    {
                                        sumDsArr.map((el, sumDsIdx) => (
                                            <li key={`sumDs_${sumDsIdx}`}>
                                                <button onClick={e => onClickSumDs(e, el.sumDsId)} disabled={selSumDsId === el.sumDsId}>{el.name}</button>
                                            </li>
                                        ))
                                    }
                                </ul>
                                : null
                        }
                    </li>
                </ul>
            </div>
            <div className='dataContentArea'>
                <Outlet context={{ selSumDsId }} />
            </div>
        </div>
    );
}

export default Data;